module.exports = __webpack_public_path__ + "img/act-公共人才库.e40c937d.png";